import React, { useCallback } from 'react'
import { DialogProps, Dialog } from '../Dialog'
import {
  ConfirmDocumentsFooter,
  ConfirmDocumentsHeader,
  ConfirmDocumentsContainer
} from './components'

export type ConfirmDocumentsTabDialogProps = {
  loading: boolean,
  onClick: () => void,
  onCancelClick: () => void
} & DialogProps

export const ConfirmDocumentsTabDialog: React.FC<ConfirmDocumentsTabDialogProps> = (props) => {
  const { loading, onClick, onClose, isVisible, onCancelClick } = props

  const onModalClose = useCallback(() => {
    if (loading) {
      return
    }

    onClose()
  }, [loading, onClose])

  return (
    <Dialog
      maxWidth='md'
      isVisible={isVisible}
      onClose={onModalClose}
      disableClose={loading}
    >
      <ConfirmDocumentsContainer>
        <ConfirmDocumentsHeader />
        <ConfirmDocumentsFooter
          loading={loading}
          onClick={onClick}
          onCancelClick={onCancelClick}
        />
      </ConfirmDocumentsContainer>
    </Dialog>
  )
}
